(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compare-machines"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (section) => {
    if (!section || section.dataset.lpCompareReady === 'true') return;
    const dataNode = section.querySelector('[data-products-json]');
    if (!dataNode) return;
    let payload;
    try { payload = JSON.parse(dataNode.textContent); } catch (error) { console.error('LP comparison data could not be read.', error); return; }
    const products = Array.isArray(payload.products) ? payload.products : [];
    if (products.length < 2) return;
    const byHandle = new Map(products.map((product) => [product.handle, product]));
    const selectA = section.querySelector('[data-product-select="a"]');
    const selectB = section.querySelector('[data-product-select="b"]');
    const notice = section.querySelector('[data-same-product-notice]');
    if (!selectA || !selectB) return;
    const normaliseValue = (value) => value === null || value === undefined || value === '' ? '—' : String(value);
    const escapeHtml = (value) => String(value ?? '').replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('"','&quot;').replaceAll("'",'&#039;');
    const renderCard = (side, product) => {
      const card = section.querySelector(`[data-product-card="${side}"]`); if (!card || !product) return;
      const imageMarkup = product.image ? `<img class="lp-compare__image" src="${escapeHtml(product.image)}" alt="${escapeHtml(product.imageAlt)}" loading="lazy" width="900" height="675">` : '<div class="lp-compare__image-placeholder">No image available</div>';
      const comparePrice = product.compareAtPrice ? `<span class="lp-compare__compare-price">${escapeHtml(product.compareAtPrice)}</span>` : '';
      const rating = product.rating && product.rating !== 'Not rated' ? `<p class="lp-compare__rating" aria-label="Overall rating ${escapeHtml(product.rating)}">${escapeHtml(product.rating)}</p>` : '';
      const button = product.url ? `<a class="lp-compare__button" href="${escapeHtml(product.url)}">${escapeHtml(product.buttonLabel || payload.settings.buttonLabel)}</a>` : '';
      const priceMonitor = `<div class="lp-compare__price-monitor" aria-label="LP price monitoring"><div class="lp-compare__price-monitor-top"><div class="lp-compare__price-monitor-title"><span class="lp-compare__price-monitor-dot" aria-hidden="true"></span><span>LP PRICE MONITORING</span></div><span class="lp-compare__price-monitor-date">${new Date().toLocaleDateString('en-GB',{day:'numeric',month:'long',year:'numeric'})}</span></div><p class="lp-compare__price-monitor-text"><span class="lp-compare__price-monitor-desktop">We monitor prices across leading UK metal detecting retailers.</span><span class="lp-compare__price-monitor-mobile">Checked against leading UK retailers.</span></p></div>`;
      card.innerHTML = `<div class="lp-compare__image-wrap">${imageMarkup}</div><div class="lp-compare__product-content"><p class="lp-compare__vendor">${escapeHtml(product.vendor)}</p><h3 class="lp-compare__product-title">${escapeHtml(product.title)}</h3>${rating}<div class="lp-compare__price-row"><span class="lp-compare__price">${escapeHtml(product.price)}</span>${comparePrice}</div><p class="lp-compare__stock">${escapeHtml(product.availability)}</p>${priceMonitor}${button}</div>`;
    };
    const renderGuidance = (side, product) => {
      const title = section.querySelector(`[data-guidance-title="${side}"]`), text = section.querySelector(`[data-guidance-text="${side}"]`); if (!title || !text || !product) return;
      title.textContent = `${payload.settings.guidancePrefix} ${product.title}`;
      const guidance = normaliseValue(product.guidance); const guidanceText = guidance === '—' ? payload.settings.fallbackGuidance : guidance;
      const verdictMarkup = product.verdictHtml ? `<div class="lp-compare__verdict"><strong>LP verdict:</strong>${product.verdictHtml}</div>` : '';
      text.innerHTML = `<p>${escapeHtml(guidanceText)}</p>${verdictMarkup}`;
    };
    const renderSpecs = (a,b) => section.querySelectorAll('[data-spec-row]').forEach((row) => {
      const id=row.dataset.specRow, va=normaliseValue(a?.specs?.[id]), vb=normaliseValue(b?.specs?.[id]);
      const ca=row.querySelector('[data-spec-value="a"]'), cb=row.querySelector('[data-spec-value="b"]');
      if(ca){ca.textContent=va;ca.classList.toggle('lp-compare__different',va!==vb&&va!=='—');}
      if(cb){cb.textContent=vb;cb.classList.toggle('lp-compare__different',va!==vb&&vb!=='—');}
      row.hidden=va==='—'&&vb==='—';
    });
    const render = () => {
      const a=byHandle.get(selectA.value), b=byHandle.get(selectB.value); if(notice) notice.hidden=selectA.value!==selectB.value;
      renderCard('a',a);renderCard('b',b);renderGuidance('a',a);renderGuidance('b',b);renderSpecs(a,b);
      const ta=section.querySelector('[data-table-title="a"]'),tb=section.querySelector('[data-table-title="b"]');if(ta)ta.textContent=a?.title||'';if(tb)tb.textContent=b?.title||'';
    };
    const slugifyDetector = (value) => String(value || '')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    const productMatchValues = (product) => {
      const title = String(product?.title || '');
      const vendor = String(product?.vendor || '');
      const titleWithoutVendor = title.replace(new RegExp(`^${vendor}\\s+`, 'i'), '');

      return new Set([
        String(product?.handle || ''),
        slugifyDetector(product?.handle),
        slugifyDetector(title),
        slugifyDetector(titleWithoutVendor),
        slugifyDetector(`${vendor} ${title}`),
        slugifyDetector(`${vendor} ${titleWithoutVendor}`)
      ].filter(Boolean));
    };

    const findRequestedProduct = (requestedValue) => {
      if (!requestedValue) return null;
      const rawValue = String(requestedValue);
      const normalisedValue = slugifyDetector(rawValue);

      return products.find((product) => {
        const values = productMatchValues(product);
        return values.has(rawValue) || values.has(normalisedValue);
      }) || null;
    };

    const query = new URLSearchParams(window.location.search);
    const requestedA = findRequestedProduct(query.get('detector1'));
    const requestedB = findRequestedProduct(query.get('detector2'));

    selectA.value = requestedA?.handle || products[0].handle;

    const fallbackB = products.find((product) => product.handle !== selectA.value) || products[1];
    selectB.value = requestedB?.handle || fallbackB.handle;

    if (selectB.value === selectA.value) {
      selectB.value = fallbackB.handle;
    }

    selectA.addEventListener('change',render);
    selectB.addEventListener('change',render);
    render();
    section.dataset.lpCompareReady='true';
  };
  document.querySelectorAll('[id^="LPDetectorComparison-"]').forEach(initialise);
  document.addEventListener('shopify:section:load',(event)=>initialise(event.target.querySelector('[id^="LPDetectorComparison-"]')||event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
